import React, { useEffect, useState } from 'react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import { Divider } from '@material-ui/core';
import DialogActions from '@material-ui/core/DialogActions';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import DialogContent from '@material-ui/core/DialogContent';
import Checkbox from '@material-ui/core/Checkbox';
import { DatePicker } from 'material-ui-pickers';
import MomentUtils from 'material-ui-pickers/utils/moment-utils';
import { MuiPickersUtilsProvider } from 'material-ui-pickers';
import { KeyboardArrowLeft } from '@material-ui/icons';
import { KeyboardArrowRight } from '@material-ui/icons';
import moment from 'moment';
import { issueDraftSearches } from 'Actions/projectActions';
import { connect } from 'react-redux';

const IssueDraft = ({
  tickets,
  onClose,
  open,
  issueDraftSearches,
  projectId,
}) => {
  const [checkboxValue, setCheckboxValue] = useState([]);
  const [date, setDate] = useState(
    new Date().setDate(new Date().getDate() + 7)
  );

  const handleClose = () => {
    onClose();
    setDate(new Date().setDate(new Date().getDate() + 7));
    handleSelectAll(false);
  };

  const handleDateChange = date => {
    setDate(date);
  };

  const handleSelectAll = checked => {
    setCheckboxValue(isChecked => {
      return isChecked.map(item => {
        return { id: item.id, name: item.name, isChecked: checked };
      });
    });
  };

  const handleCheckboxChange = (index, checked) => {
    setCheckboxValue(isChecked => {
      return isChecked.map((item, idx) => {
        if (idx === index)
          return { id: item.id, name: item.name, isChecked: checked };
        return item;
      });
    });
  };

  const handleSubmit = () => {
    let tempArr = [];
    checkboxValue.map(item => {
      if (item.isChecked) tempArr.push(item.id);
    });
    const issue = {
      ids: tempArr,
      date: moment(date).format('YYYY/MM/DD'),
    };
    if (tempArr.length !== 0) {
      issueDraftSearches(issue, projectId);
      handleClose();
    }
  };

  useEffect(() => {
    if (tickets.length) {
      let tempArr = [];
      tickets.forEach(item => {
        if (item.state === 'DRAFT')
          tempArr.push({
            id: item.ticketId,
            name: item.referenceName,
            isChecked: false,
          });
      });
      setCheckboxValue(tempArr);
    }
  }, [tickets]);

  return (
    <Dialog
      classes={{
        paper: 'e-zindex--max bc-gray share-dialog',
      }}
      maxWidth="sm"
      open={open}
      onClose={handleClose}
    >
      <h4 className="t-primary-20 t-weight--b t-align-c u-mrg-top-50 u-mrg-bot-30 u-pad-r-25 u-pad-l-25">
        {checkboxValue.length
          ? 'Issue the following draft searches'
          : `There aren't draft tickets for issue`}
      </h4>

      <DialogContent>
        {checkboxValue.length ? (
          <div>
            <div>
              {checkboxValue.map((item, index) => (
                <FormControlLabel
                  key={index}
                  control={
                    <Checkbox
                      value={item.name}
                      checked={item.isChecked}
                      onChange={e =>
                        handleCheckboxChange(index, e.target.checked)
                      }
                    />
                  }
                  label={item.name}
                />
              ))}
            </div>
            <Divider light />
            <div>
              <FormControlLabel
                control={
                  <Checkbox
                    value="Select all"
                    onChange={e => handleSelectAll(e.target.checked)}
                  />
                }
                label="Select all"
              />
            </div>
            <div className="u-mrg-top-30">
              <MuiPickersUtilsProvider utils={MomentUtils}>
                <DatePicker
                  fullWidth
                  clearable
                  leftArrowIcon={<KeyboardArrowLeft />}
                  rightArrowIcon={<KeyboardArrowRight />}
                  value={date}
                  minDate={new Date().setDate(new Date().getDate() + 1)}
                  onChange={handleDateChange}
                  label="Issued searches expire"
                  format="YYYY MMM DD"
                  minDateMessage={'Search expire date must be after start date'}
                />
              </MuiPickersUtilsProvider>
            </div>
          </div>
        ) : null}
      </DialogContent>

      <DialogActions>
        <Button
          classes={{
            root: 't-primary-16 c-blue-2-light t-weight-b',
          }}
          onClick={handleClose}
        >
          {checkboxValue.length ? 'Cancel' : 'Close'}
        </Button>
        {checkboxValue.length ? (
          <Button
            classes={{
              root: 't-primary-16 c-s-blue',
            }}
            onClick={handleSubmit}
            variant="contained"
            color="primary"
          >
            Ok
          </Button>
        ) : null}
      </DialogActions>
    </Dialog>
  );
};

const mapDispatchToProps = dispatch => ({
  issueDraftSearches: (issue, projectId) => {
    dispatch(issueDraftSearches(issue, projectId));
  },
});

export default connect(null, mapDispatchToProps)(IssueDraft);
